export enum Cartridges {
  Digger = 'Digger',
  Doom = 'Doom',
  Mario = 'Mario',
  Quake = 'Quake',
  Duke = 'Duke',
  DonkeyKong = 'DonkeyKong',
  Wolfenstein = 'Wolfenstein',
}
